import React from 'react'
import Hero from './hero/Hero'
// import Featured from './featured/Featured'
// import Price from './price/Price'
import Slide from './slide/Slide'
import Recent from "../home/recent/Recent"

const Home = () => {
  return (
    <>
        <Hero/>
        {/* <Featured/> */}
        <Slide/>
        <Recent/>
        {/* <Price/> */}
    </>
  ) 
}

export default Home